import { render, staticRenderFns } from "./OrdineCampiCard.vue?vue&type=template&id=528048a8&scoped=true"
import script from "./OrdineCampiCard.vue?vue&type=script&lang=js"
export * from "./OrdineCampiCard.vue?vue&type=script&lang=js"
import style0 from "./OrdineCampiCard.vue?vue&type=style&index=0&id=528048a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528048a8",
  null
  
)

export default component.exports